import VidConf from './vidConf';
import JoinRoom from './joinRoom';
import QrModal from './qrModal';
import AddContactModal from './addContactModal';
import React, {useRef , useEffect , useState} from 'react';
import { useCurrentUser } from '../hooks/useCurrentUser';
import '@passageidentity/passage-elements/passage-register';
import { selectPeers, 
    selectIsConnectedToRoom,
    useHMSActions,
    useHMSStore, 
    useScreenShare,
    selectIsInPreview} from "@100mslive/react-sdk";
import  guestCredentials  from '../seeders/guestCredentials';
import {AppState} from '../context/AppProvider'
import EnvRoute from '../middleware/envRoute';
import axios from "axios";


const ENDPOINT = EnvRoute('prod'); 



// let meetings = require('../seeders/seedMeetings.json');
// let canvas = React.createRef();

// const NDAER_URL_NGROK = "https://86a2-2600-1700-6450-4000-e90b-7ad6-121e-da45.ngrok.io/documents"
// const NDAER_URL=  "http://localhost:3001/documents"
// const Guest_vid ="https://townhall.app.100ms.live/meeting/ymm-jmt-lsr"
// const guest = guestCredentials

//  let el2
function Hub(props) {
    let { isLoading, isAuthorized, username, p_user_id, re, user_metadata } = useCurrentUser();
       const {
        view,
        setView,
        room,
        setRoom,
        user,
        setUser,
        meetings,
        setMeetings,
        currentMeeting,
        setCurrentMeeting,
        notifications,
        setNotifications,
    
        setIsLoading } = AppState()
        const localUser = JSON.parse(localStorage.getItem('TH_user'))
        console.log('[hub] localUser: ',localUser)
    if(!user.token){ localUser? setUser(localUser) : console.log('[Hub] inital: No User Info')}
    // if(user.token){ setUser( JSON.parse(localStorage.getItem('TH_user'))) }
    // console.log("Hub username: ", username )
    // window.localStorage.setItem('cur_user',JSON.stringify(username))
    const [ showQr , setShowQr ] = useState(false)
    const [ showConnect , setShowConnect ] = useState(false)
    const [ qrPos , setQrPos ] = useState('qr-down-hub')

    // setUser(guest)
    const alerts = [3,2,4,5,1]

    const cur_URL = window.location.href
    console.log("Hub cur_URL: ",  cur_URL )
    let QR_user = ''
    let QR_meeting_id = ''
    let QR_event_id = ''
    const [QR_data , setQrData ] = useState('')
    const [QR_type , setQrType ] = useState('')

     const fetchMeetings = async () =>{
         console.log('[fetchMeetings]  user.token: ',localUser?.token)
     try {
      const config = {
        headers: {
         // Authorization: `Bearer ${user.token}`,//!---production
        //  'Content-Type': 'application/json', 
          Authorization: `Bearer ${localUser?.token}`,
        },
        body: {
           _id: localUser?._id
        }
      };

      // console.log("pre fetch user: ", user)
      const data  = await axios.post(`${ENDPOINT}/api/meeting/all`,{_id: localUser._id}, config)
    //   const data  = await axios.post(`${ENDPOINT}/api/meeting/all`, config)
      console.log("data: ", ...data.data)
      let resp = [...data.data]
      try{
         localStorage.setItem("TH_meetings", JSON.stringify(resp));

        let TH_meetings = JSON.parse(localStorage.getItem("TH_meetings"));
        console.log(('[Hub] TH_meetings: ',TH_meetings));
        setMeetings(JSON.parse(localStorage.getItem("TH_meetings")));

        //    let  mtgs = data.data
        //   setMeetings([...mtgs]);
        }catch(er){console.log('Meetings not set.',er)}
    } catch (err) {console.log(err)}
         setMeetings(localStorage.getItem("TH_meetings"));

    // console.log("[Hub] fetchMeetings ---> Meetings: ", meetings)
    
}

    function  checkURL(){
        if(window.location.href.includes('?u=')){
            let  temp_arr = cur_URL.split('=')
            console.log("QR Link: ", temp_arr[1])
            QR_user = temp_arr[1]
            setQrData(QR_user)
            setQrType('user')
            // return temp_arr[1]
        }
        else if(window.location.href.includes('?mt=')){
            let  temp_arr = cur_URL.split('=')
            console.log("QR Meeting: ", temp_arr[1])
            QR_meeting_id = temp_arr[1]
            setQrData(QR_meeting_id)
            setQrType('meeting')
            // return temp_arr[1]
        }
        else if(window.location.href.includes('?ev=')){
            let  temp_arr = cur_URL.split('=')
            console.log("QR Event: ", temp_arr[1])
            QR_event_id = temp_arr[1]
            setQrData(QR_event_id)
            setQrType('event')
            // return temp_arr[1]
        }
        // else{
        //     setQrData(false)
        //     setQrType(false)
        // }
        }   
        const discoverClick = () =>{
            return
        }

        useEffect(()=>{
            console.log('[Hub] user:', user)
            checkURL()
            // if(!meetings){fetchMeetings()}
           fetchMeetings()
            if((QR_data)){
            // if((QR_Data) && (QR _user !== username) ){
                if((QR_type ==='user')){
                    localStorage.setItem('QR_user','')
                    localStorage.setItem('QR_user',JSON.stringify(QR_user))
                    console.log("Storing QR_user", QR_user)
                    setShowConnect(true)
                }
                if((QR_type === 'meeting')){
                    localStorage.setItem('QR_meeting_id','')
                    localStorage.setItem('QR_meeting_id',JSON.stringify(QR_meeting_id))
                    console.log("Storing QR_meeting_id", QR_meeting_id)
                    setShowConnect(true)
                }
                if((QR_type === 'event') ){
                    localStorage.setItem('QR_event_id','')
                    localStorage.setItem('QR_event_id',JSON.stringify(QR_event_id))
                    console.log("Storing QR_event_id", QR_event_id)
                    setShowConnect(true)
                }
            }
    },[])

  function toggleQR(){   
      if(!showQr){
        setShowQr(true)
        setQrPos('qr-up-hub')
        }else{
            setQrPos('qr-down-hub')
          setShowQr(false)
            }
          console.log("toggleEventVid click")
        }
    
  function toggleUserInfo(){   
    //   if(!showQr){
    //     setShowQr(true)
    //     setQrPos('qr-up-hub')
    //     }else{
    //         setQrPos('qr-down-hub')
    //       setShowQr(false)
    //         }
          console.log("toggle user info click")
        }

  // }, []);

  let qrLinkClass = `qr-link hub-button blink-faster`
    return (
        <div className="hub-container center">
             {/* <div className="meetings-header-wrap" id="meetings-header-wrap" > */}
            <div className="hub-header" id="hub-header" >
                <div id="scroll-container" onClick={toggleUserInfo}>  
                    <div id="scroll-text">
                        greetings: &nbsp;
                        <span className='user-text'> 
                           {user?.preferredName}
                            </span>
                    </div>   
                        {/* <br></br> */}
                       
                
                    
                {/* </div> */}
              
                </div>
            </div>
                 <h1 className="view-header blink-slower" id = "hub-title" >{view}</h1>
            <div className='hub-content-wrap center'>
            {/* <div className='center'> */}
            <span id="hub-prof-link" className = "hub-icon-buttons">
                <img  src="/images/user-solid.svg" alt="user icon" className="blink "/>
            </span>
            <span id="hub-alert-link" className="hub-icon-buttons">
                                <img  src="/images/bell.svg" alt="user icon" className="blink "/>
                                <span className="alert-num">{alerts[4]}</span>
                            </span>       
                <div className='hub-button-wrap'>
                    <button
                        id="hub-contact-link"
                        className="hub-button blink"
                        onClick={(e) =>{ 
                            e.preventDefault()
                            setView('meetings')
                            window.location.href = `/meetings`
                            }}
                         >
                        <span>
                            Meetings
                           
                            <img src="/images/scale-balanced-solid.svg" />
                            <span className="alert-num">{alerts[1]}</span>
                        </span>
                    </button>

                    <button
                        id="hub-contact-link"
                        className="hub-button blink-faster"
                        onClick={() =>window.location.href = `/events`}
                        >
                        <span>
                            Events
                            <img src="/images/calendar.svg" />
                            <span className="alert-num">{alerts[0]}</span>
                        </span>
                    </button>

                    <button
                        // id="leave-btn"
                        id="hub-contact-link"
                        className="hub-button blink-slower"
                        onClick={() =>window.location.href = `/contacts`}
                        >
                            <span>
                                contacts
                                <img src="/images/id-card.svg" alt="contacts card" />
                                <span className="alert-num">{alerts[3]}</span>
                            </span>
                    </button>
                    <div className="hub-button blink-slower" id="hub-discover-link" onClick={discoverClick}>     
                       <span >
                            discover
                            <img src="/images/globe.svg" alt="discover globe"/>
                            <span className="alert-num">{alerts[0]}</span>
                            {/* <br></br> */}
                       </span>
                    </div>

                    <div className={qrLinkClass} id="hub-qr" onClick={toggleQR}>  

                        {/* <div> */}
                            <img src="/images/qrcode.svg" alt ="connect Qr"/>
                            {/* connect */}
                        {/* </div> */}
                    </div>
                    
                </div>
                { showConnect &&(
                    <AddContactModal user={user?.email} QR_Data={QR_data}  QR_Type={QR_type}  view ={view}/>

                )}
                {/* {showQr &&( */}
                    <div className = {`qr-wrap ${qrPos} `}>
                       <div id="qr-modal-close" onClick={toggleQR}>close</div>
                        <QrModal meeting_id ='' user={user?.email} view ={view}/>
                    </div>
                {/* )} */}
            </div>
           

      </div>

  );
}
export default Hub; 